<div class="tw:my-4 tw:rounded-lg tw:bg-primary-50 tw:px-4 tw:py-3">
    <div class="tw:mb-4 tw:flex tw:items-center tw:justify-between">
        <div class="tw:text-lg tw:font-semibold tw:text-primary-500">
            {{ 'SHARED.createBookingModal.saleRecord' | translate }}
        </div>
        <app-sales-status [sale]="sale" />
    </div>

    @if (payments.length) {
        <div class="tw:text-sm">
            @for (payment of payments; track payment.id ?? $index) {
                <div
                    class="tw:border-t tw:border-primary-100 tw:py-3 tw:text-success-800 tw:flex tw:items-center tw:justify-between"
                >
                    <div class="tw:font-semibold">
                        {{ payment.paymentMethod | paymentMethod: payment.isOnlinePayment }}
                        @if (payment.paidAt) {
                            ({{ payment.paidAt | date: 'short' }})
                        }
                    </div>
                    <div class="tw:font-semibold">+{{ payment.amount | merchantCurrency }}</div>
                </div>
            }
            @if (sale.tip > 0) {
                <div
                    class="tw:border-t tw:border-primary-100 tw:py-3 tw:text-success-800 tw:flex tw:items-center tw:justify-between"
                >
                    <div class="tw:font-semibold">{{ 'SALE_DETAILS.tip' | translate }}</div>
                    <div class="tw:font-semibold">+{{ sale.tip | merchantCurrency }}</div>
                </div>
            }
        </div>
    }

    @if (sale?.missingPayment > 0) {
        <div class="tw:text-error-800 tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm">
            <div class="tw:font-semibold">{{ 'SALES_STATUS.pending' | translate }}</div>
            <div class="tw:font-semibold">{{ sale.missingPayment | merchantCurrency }}</div>
        </div>
    }

    <div class="tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm tw:text-neutral-500">
        <div class="tw:font-semibold">{{ 'GENERAL.total' | translate }}</div>
        @if (totalPriceCents && totalPriceCents !== sale?.totalCents) {
            <div class="tw:flex tw:gap-2">
                <div class="tw:line-through">{{ totalPriceCents / 100 | merchantCurrency }}</div>
                <div class="tw:font-semibold">{{ sale?.total | merchantCurrency }}</div>
            </div>
        } @else {
            <div class="tw:font-semibold">{{ sale?.total | merchantCurrency }}</div>
        }
    </div>

    @if (showPrePaymentLink) {
        <div class="tw:mt-3 tw:flex tw:flex-col tw:gap-3 tw:border-t tw:border-primary-100 tw:pt-3">
            <button
                type="button"
                class="tw:flex tw:w-full tw:cursor-pointer tw:items-center tw:justify-center tw:gap-2 tw:border-0 tw:bg-transparent tw:p-0 tw:text-sm tw:leading-5 tw:text-neutral-500 hover:tw:opacity-80"
                [attr.aria-expanded]="prePaymentLinkExpanded"
                (click)="togglePrePaymentLink.emit()"
            >
                <span aria-hidden="true">
                    <span class="material-icons tw:block tw:!text-[18px] tw:!leading-none">{{
                        prePaymentLinkExpanded ? 'visibility_off' : 'visibility'
                    }}</span>
                </span>
                <span class="tw:leading-5">{{ 'SHARED.createBookingModal.prePaymentLink' | translate }}</span>
            </button>
            @if (prePaymentLinkExpanded && !prePaymentLinkLoading) {
                <app-clipboard-input [url]="prePaymentLinkUrl" />
            }
        </div>
    }

    <div
        class="tw:flex"
        [class.tw:justify-between]="footerJustifyBetween"
        [class.tw:justify-center]="!footerJustifyBetween"
    >
        @if (showSeeRegister) {
            <app-button extraClass="tw:!px-0" size="sm" type="transparent" (clickEvent)="seeSaleDetails.emit()">
                {{ 'SHARED.createBookingModal.seeRegister' | translate }}
            </app-button>
        }
        @if (showEditSale) {
            <app-button extraClass="tw:!px-0" type="transparent" size="sm" (clickEvent)="editSale.emit()">
                {{ 'INVOICE_PREVIEW.editSale' | translate }}
            </app-button>
        }
    </div>
</div>
